export default __webpack_public_path__ + "static/media/test_sound.02e72e39.mp3";